import React from "react";
import { useMutation } from "react-query";
import { secureAxios } from "../_helpers/auth";
import { queryClient } from "../_helpers/query";
import { useCurrentUser, useUpdateMe } from "./auth";

import log from "cslog";

export const useCreateOrg = (onSuccess = () => { }) => {
    const updateMutationUser = useUpdateMe();
    return useMutation(
        (newItem) => {
            return secureAxios
                .post(`/items/qdb_organization`, newItem)
                .then((res) => res.data);
        },
        {
            onSuccess: (data, variables, context) => {
                onSuccess();
                queryClient.invalidateQueries(["user"]);
            },
            onError: (error, variables) => {
                log.d(
                    error.response.data.errors[0].extensions.code,
                    "orgError"
                );
                if (
                    error?.response?.data.errors?.[0]?.extensions?.code ===
                    "RECORD_NOT_UNIQUE"
                ) {
                    log.d(variables, "variables");
                    updateMutationUser.mutate({
                        organizations: [{ qdb_organization_id: variables.id }],
                        owned_organizations: [{ qdb_organization_id: variables.id }],
                        selected_org: variables.id,
                    });
                }
                // console.log("Error creating org", error);
            },
        }
    );
};

export const useUpdateOrgMutation = (onSuccess = () => { }) => {
    return useMutation(
        (data) =>
            secureAxios
                .patch(`/items/qdb_organization/${data.id}`, data.data)
                .then((res) => res.data),
        {
            onSuccess: (data, variables) => {
                onSuccess();
                queryClient.invalidateQueries(["user"]);
            },
        }
    );
};

export const useSelectedOrg = () => {
    const { isLoading, isSuccess, data: dataMe } = useCurrentUser();
    return {
        isLoading,
        isSuccess,
        data: dataMe?.selected_org,
    };
};

export const useSelecteOrgMutation = (onSuccess = () => { }) => {
    return useMutation(
        (org_id) => {
            return secureAxios
                .patch("/users/me", { selected_org: org_id })
                .then((res) => res.data);
        },
        {
            onSuccess: (data, variables, context) => {
                onSuccess();
                queryClient.invalidateQueries(["user"]);
            },
        }
    );
};